import React from 'react'
import styles from "../tnpsc-admissions/tnpsc-admissions.module.css";
import Link from 'next/link';

const About_TNPSC = () => {

    const tnpsclist4 = [
        { contlist: "TNPSC Group I Main Examination*" },
        { contlist: "Modern History of India and Indian Culture" },
        { contlist: "General Mental Ability" },
        { contlist: "Role and Impact of Science and Technology in the development of India and Tamil Nadu" }
    ]

    const tnpsclist5 = [
        { contlist: "Indian Polity and emerging political trends across the" },
        { contlist: "world affecting India and Geography of India" },
        { contlist: "Tamil language, Tamil society–its culture and heritage / English language, English language skills" },
        { contlist: "Administration of Union and States with special reference to Tamil Nadu" }
    ]

    const tnpsclist6 = [
        { contlist: "Current events of national and international importance" },
        { contlist: "Current economic trends; Indian economy and impact of global economy on India" },
        { contlist: "Socio-economic issues in India and Tamil Nadu" }
    ]

    return (
        <>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h2 className={`${styles.sectiontitle}`}>Prelims Syllabus</h2>
                        <p className={`${styles.acheiverrank} mb-0`}>TNPSC Group I, Group II and Group II A Preliminary Examination – Questions will be asked from the following topics*</p>
                        <p className={`${styles.acheiverrank} mb-0`}>General Science | Current events | Geography | History and Culture of India | Indian Polity | Indian Economy | Indian National Movement |
                            Aptitude and Mental Ability</p>
                        <p className={`${styles.acheiverrank} mb-0`}>Language: General Tamil (or) General English (Only for Group II, Group II A).</p>
                        <p className={`${styles.acheiverrank}`}>*For detailed syllabus refer : <span className={`${styles.redunderline} mb-0`}><Link href="/tnpsc-admissions" className={`${styles.redunderlinealink}`}>English Syllabus </Link> <span style={{ color: "#141C26" }}>&nbsp;|&nbsp;</span> <Link href="/tnpsc-admissions" className={`${styles.redunderlinealink}`}> Tamil Syllabus</Link></span></p>
                    </div>
                </div>
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-12" >
                        <div className='p-3 h-100' style={{ border: "1px solid #707070" }}>
                            <p className={`${styles.contenttitles} mb-1`}>Group I Mains Syllabus</p>
                            <p className={`${styles.aboutheading2} mb-1`}>PAPER – I / Unit I</p>
                            {tnpsclist4.map((item, index) => (
                                <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index} >
                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                                {item.contlist}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            ))}
                            <p className={`${styles.aboutheading2} pt-3 mb-1`}>PAPER – II / Unit II and III</p>
                            {tnpsclist5.map((item, index) => (
                                <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                                {item.contlist}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            ))}
                            <p className={`${styles.aboutheading2} pt-3 mb-1`}>PAPER – III / Unit IV and V</p>
                            {tnpsclist6.map((item, index) => (
                                <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`} key={index}>
                                    <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                        <div className="d-inline">
                                            <p className={`${styles.ullispan} d-inline`}>
                                                {item.contlist}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            ))}
                        </div>
                    </div>
                    <div className="col-lg-6 col-12 pt-3 pt-lg-0">
                        <div className='p-3 h-100' style={{ border: "1px solid #707070" }}>
                            <p className={`${styles.contenttitles} mb-1`}>Group II Mains Syllabus</p>
                            <p className={`${styles.aboutheading2} mb-1`}>PAPER – I / Unit I</p>
                            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                            TNPSC Group II (Interview Post) Main Examination
                                        </p>
                                    </div>
                                </li>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                            Role and Impact of Science and Technology in the development of India and Tamil Nadu
                                        </p>
                                    </div>
                                </li>
                            </ul>
                            <p className={`${styles.aboutheading2} pt-3 mb-1`}>PAPER – II / Unit II and III</p>
                            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                            Administration of Union and States with special reference to Tamil Nadu
                                        </p>
                                    </div>
                                </li>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                            Socio-economic issues in India and Tamil Nadu
                                        </p>
                                    </div>
                                </li>
                            </ul>
                            <p className={`${styles.aboutheading2} pt-3 mb-1`}>PAPER – III / Unit IV and V</p>
                            <ul className={`${styles.ulclass} ps-1 pt-2 mb-0`}>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                            Current Issues at National Level
                                        </p>
                                    </div>
                                </li>
                                <li className={`${styles.ulliclass} ${styles.acheiverrank}`} id={styles.acheiverrankspecial}>
                                    <div className="d-inline">
                                        <p className={`${styles.ullispan} d-inline`}>
                                            Current Issues at State Level
                                        </p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default About_TNPSC;